import * as React from "react";
import { Banner } from "kanopi-components/Banner/Banner";
import { BlockProps } from "baseui/block";
import { navigate } from "@reach/router";
import { QuoteState, ReferralState } from "kw/api/zeus";
import { TPolicyUpdateQuote } from "kw/types";
import { useCallback } from "react";
import { useStyletron } from "kanopi-components/theme/useStyletron";

type TPolicyBanner = {
  policyId: string;
  policyLatestUpdate: TPolicyUpdateQuote;
};

export const PolicyStatusBanner: React.FC<TPolicyBanner & BlockProps> = ({
  policyId,
  policyLatestUpdate,
  ...props
}) => {
  const [, theme] = useStyletron();
  const navigateToPolicyConfirm = useCallback(() => {
    navigate(`/policies/${policyId}/update/confirm`);
  }, []);

  return (
    ((policyLatestUpdate?.quote?.state === QuoteState.REFERRED &&
      policyLatestUpdate?.quote?.referralState === ReferralState.PENDING) ||
      ([QuoteState.QUOTED, QuoteState.ACCEPTED].includes(
        policyLatestUpdate?.quote?.state
      ) &&
        policyLatestUpdate?.quote?.referralState === ReferralState.ACCEPTED)) && (
      <Banner
        data-testid="policyStatusBanner"
        messageColor={theme.colors.contentOnColorInverse}
        backgroundColor={theme.colors.backgroundLightNegative}
        {...props}
        message={
          policyLatestUpdate?.quote?.state === QuoteState.REFERRED
            ? "There's a policy update operation awaiting underwriter decision"
            : "Payment pending"
        }
        onButtonClick={navigateToPolicyConfirm}
        hideButton={
          ![QuoteState.QUOTED, QuoteState.ACCEPTED].includes(
            policyLatestUpdate?.quote?.state
          )
        }
        buttonText="Pay now"
      />
    )
  );
};
